<template>
  <div class="contain" ref="contain">
    <div class="wow animate__zoomInRight"
      style="font-size: max(6vw,32px);text-transform: uppercase;color: hsla(0,0%,100%,.3);font-weight: 600;letter-spacing:1px">
      WERE YOU READY FOR</div>
    <div class="wow animate__zoomInRight" data-wow-delay="0.3s"
      style="font-size: max(5vw,24px);text-transform: uppercase;color: #fff;font-weight: 600;letter-spacing:1px">COVID-19</div>
  </div>
  <div class="container">
    <!-- 左边的标题 -->
    <div class="title-column">
      <ul>
        <li v-for="(title, index) in titles" :key="index" :class="{ active: currentIndex === index }"
          @click="handleTitleClick($event, index)">
          {{ title }}
        </li>
      </ul>
    </div>
    <div class="middle-column">
      <!-- 中间的轮播图 -->
      <div class="carousel">
        <div class="carousel-inner" :style="carouselStyle" @mousedown="startDrag" @mouseup="endDrag"
          @mouseleave="endDrag">
          <img v-for="(image, index) in images" :key="index" :src="image" class="carousel-item" />
        </div>
      </div>

      <!-- 导航点 -->
      <div class="carousel-nav">
        <span v-for="(image, index) in images" :key="index" :class="{ active: currentIndex === index }" class="nav-dot"
          @click="handleNavDotClick(index)"></span>
      </div>
    </div>

    <!-- 右边的简介 -->
    <div class="description" v-for="(item, index) in descriptions[currentIndex]" :key="index">
      {{ item }}
    </div>
  </div>

  <div class="container2" ref="container2">
    <h1>Engage with our Way of Work & <br />Explore our Services in Detail</h1>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

const titles = ['Gaming', 'Project Management'];
const descriptions = [
  ["While Gaming has clearly been one of the winners in this period, it has also become one of the most crowded spaces. But are there a few tricks that most people are missing?  MYD can help your Gaming platform be ready to take on the Industry by storm!"],
  ["Work from Home, Communication, Operations and Execution have all been transformed during this pandemic. But did you know that this has actually increased efficiency and creativity for managing complex projects remotely? We would like to work as a part of your team to effectively deliver your vision!"],
];

const images = [
  require('@/assets/footerview/footer-fore-icon1.png'),
  require('@/assets/footerview/footer-fore-icon2.png'),
];

const currentIndex = ref(0);
const startX = ref(0);
const endX = ref(0);
const isMouseDown = ref(false); // 用于标记是否鼠标按下

const carouselStyle = computed(() => ({
  transform: `translateX(-${currentIndex.value * 100}%)`,
  transition: 'transform 0.3s ease', // Smooth transition
}));

const handleTitleClick = (event, index) => {
  const ripple = document.createElement('span');
  const rect = event.target.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height); // 选择较大的尺寸确保水波纹是圆形的
  const x = event.clientX - rect.left - size / 2;
  const y = event.clientY - rect.top - size / 2;

  ripple.style.width = ripple.style.height = `${size}px`;
  ripple.style.left = `${x}px`;
  ripple.style.top = `${y}px`;
  ripple.classList.add('ripple');

  event.target.appendChild(ripple);

  // 删除水波纹效果，避免过多的DOM元素
  ripple.addEventListener('animationend', () => {
    ripple.remove();
  });

  currentIndex.value = index;
};

const handleNavDotClick = (index) => {
  currentIndex.value = index;
};

const startDrag = (event) => {
  startX.value = event.clientX;  // 记录按下时的X位置
  isMouseDown.value = true;  // 鼠标按下时标记为 true
};

const endDrag = (event) => {
  if (!isMouseDown.value) return;  // 如果没有按下则不执行后续操作

  endX.value = event.clientX;  // 记录抬起时的X位置
  isMouseDown.value = false;  // 解除按下标志

  // 计算水平滑动的距离
  const distance = endX.value - startX.value;

  if (Math.abs(distance) > 30) {
    if (distance > 0) {
      // 向右滑动
      currentIndex.value = (currentIndex.value - 1 + images.length) % images.length;
    } else {
      // 向左滑动
      currentIndex.value = (currentIndex.value + 1) % images.length;
    }
  }
};


const contain = ref(null);
const container2 = ref(null);
let observer = null;

const handleIntersection = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('clip-path-effect');
    } else {
      entry.target.classList.remove('clip-path-effect');
    }
  });
};
onMounted(() => {
  observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.1 // 当元素 10% 进入视口时触发
  });
  if (contain.value) {
    observer.observe(contain.value);
  }
  if (container2.value) {
    observer.observe(container2.value);
  }
});

onUnmounted(() => {
  if (observer && contain.value) {
    observer.unobserve(contain.value);
  }
  if (observer && container2.value) {
    observer.unobserve(container2.value);
  }
});
</script>

<style lang="less" scoped>
.contain {
  background-image: url('../../assets/footerview/footer-fore-bg.png') !important;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  background-color: #fff;
  min-height: 80vh;
  position: relative;
  overflow: hidden;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果

  &.clip-path-effect {
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 80%);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 80%);
  }

  >div:nth-child(1) {
    position: absolute;
    top: 20%;
    right: 10%;
  }

  >div:nth-child(2) {
    position: absolute;
    top: 35%;
    right: 15%;
  }
}

.container {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  gap: 20px;
  width: 80%;
  margin: auto;
  justify-content: center;
  align-items: center;
}

.container2 {
  background-image: url('../../assets/footerview/footer-fore-icon3.png') !important;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  background-color: #fff;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果
  display: flex;
  justify-content: center;
  align-items: center;

  &.clip-path-effect {
    -webkit-clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 100%);
    clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 100%);
  }

  >h1 {
    font-weight: 500;
    font-size: max(2vw, 18px);
    line-height: 1.5;
  }
}

.middle-column {
  width: 30%;
}

.title-column {
  width: 30%;
  text-align: right;
  font-size: max(1.3vw,10px);
  font-weight: 300;
  text-transform: uppercase;
}

.title-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.title-column li {
  padding: 10px;
  cursor: pointer;
  margin-bottom: 5px;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.title-column li:hover,
.title-column li.active {
  background-color: #f0f0f0;
  font-weight: 700;
  font-size: max(2vw,14px);
}

.carousel {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  width: 80%;
  margin: auto;
}

.carousel-inner {
  display: flex;
  width: 100%;
}

.carousel-item {
  min-width: 100%;
  border-radius: 5px;
  user-select: none;
}

.carousel-nav {
  display: flex;
  justify-content: center;
  margin: 2vw 0px;
}

.nav-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #ccc;
  margin: 0 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.nav-dot.active {
  background-color: #0a0f38;
}

.description {
  width: 30%;
  text-align: center;
  color: #828282;
  line-height: 1.7;
  font-weight: 300;

  >ul {
    margin: 0px;
    padding: 0px;
    color: #828282;

    >li {
      margin: 2vw 0px;
    }
  }
}

.description p {
  font-size: 16px;
}

:deep(.ripple) {
  position: absolute;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.3);
  transform: scale(0);
  animation: ripple-animation 0.6s linear;
}

@keyframes ripple-animation {
  to {
    transform: scale(4);
    opacity: 0;
  }
}

@media all and (max-width:600px) {
  .contain {
    min-height: 0px;
    aspect-ratio: 5/6 !important;
    
  >div:nth-child(1) {
    top: 28%;
    right: 3%;
    text-align: right;
  }

  >div:nth-child(2) {
    top: 47%;
    right: 3%;
  }
  }

  .container {
    flex-direction: column;

    >div {
      width: 100%;
      text-align: center;
    }
  }

  .container2 {
    min-height: 0px;
    aspect-ratio: 5/7 !important;

    &.clip-path-effect {
      -webkit-clip-path: polygon(0 0, 100% 15%, 100% 100%, 0 100%);
      clip-path: polygon(0 0, 100% 15%, 100% 100%, 0 100%);
    }
  }

  .title-column ul {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
